import { Controller } from "@hotwired/stimulus";

// Both state inputs share the family[state] name; disabling the hidden one keeps it out of the submitted params.
export default class extends Controller {
  static targets = ["country", "usState", "otherState", "stateLabel", "zipLabel", "zip"];

  connect() {
    this.toggle();
  }

  toggle() {
    const country = this.countryTarget.value;
    const domestic = country === "US";

    this.setVisible(this.usStateTarget, domestic);
    this.setVisible(this.otherStateTarget, !domestic);

    if (this.hasStateLabelTarget) {
      this.stateLabelTarget.textContent = domestic ? "State*" : "Province / Region";
      this.zipLabelTarget.textContent = domestic ? "Zip*" : "Postal code";
      this.otherStateTarget.placeholder = country === "XX" ? "Region, Country" : "";
    } else {
      this.otherStateTarget.placeholder = country === "XX" ? "Region, Country" : "Province / Region";
      this.zipTarget.placeholder = domestic ? "Zip Code*" : "Postal code";
    }
  }

  setVisible(element, visible) {
    element.hidden = !visible;
    element.disabled = !visible;
  }
}
